/** Processing completion is distinct from a completed professional valuation. */
export function isFullValuationComplete(
  report:
    | {
        status?: string | null;
        collectionPurpose?: string | null;
        failureReason?: string | null;
        mostLikelyValue?: bigint | number | null;
      }
    | null
    | undefined,
): boolean {
  return Boolean(
    report &&
      (!report.collectionPurpose || report.collectionPurpose === "FULL") &&
      report.status === "COMPLETED" &&
      !report.failureReason &&
      report.mostLikelyValue != null,
  );
}
